import type { VendorMetadataExtractor, ExtractedIncidentMeta } from './types'
import { scanFileForGprmc } from './nmea'

export const blackvueExtractor: VendorMetadataExtractor = {
  vendorId: 'blackvue',
  vendorLabel: 'BlackVue',
  supportsDirectoryBrowse: false,

  async extractFromFiles(files: File[]): Promise<ExtractedIncidentMeta | null> {
    // BlackVue embeds GPS as ASCII NMEA strings prefixed with "gps [n]$GPRMC,...".
    // Scan the first video file for a valid GPRMC fix.
    const videoFile = files.find((f) => f.type.startsWith('video/') || f.name.endsWith('.mp4'))
    if (!videoFile) return { dateTime: new Date(files[0]?.lastModified) }

    const result = await scanFileForGprmc(videoFile)
    if (!result) return { dateTime: new Date(videoFile.lastModified) }

    return {
      dateTime: result.dateTime,
      lat: result.lat,
      lon: result.lon
    }
  }
}
